import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CleaverService } from 'src/app/services/cleaver.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-cleaver-factor',
  templateUrl: './create-cleaver-factor.component.html',
  styleUrls: ['styles.css'
  ]
})
export class CreateCleaverFactorComponent implements OnInit {

  public cleaverFactorForm = this.fb.group({
    type:['default'],
    personal:[[{
      low:[''],
      high:[''],
      d:[''],
      i:[''],
      s:[''],
      c:['']
    }]],
    behaviors:[[{
      combination:[''],
      title:[''],
      description:['']
    }]],
    maxMin:[[{
      tag:[''],
      description:[''],
      title:[''],
      wish:[''],
      require:['']
    }]]
  })

  public maxMinArray = [];
  public maxMin = {
    tag:"default",
    description:"",
    title:"",
    wish:'',
    require:''
  }

  public personalArray = [];
  public personal={
    low:Number,
    high:Number,
    d:"",
    i:"",
    s:"",
    c:""
  };

  public behaviorsArray = [];
  public behavior={
    combination:"default",
    title:"", 
    description:""
  };

  constructor(private fb:FormBuilder, private cleaverService:CleaverService) { }

  ngOnInit(): void {
  }
  register(){
      this.cleaverFactorForm.get('personal').setValue(this.personalArray);
      this.cleaverFactorForm.get('behaviors').setValue(this.behaviorsArray);
      this.cleaverFactorForm.get('maxMin').setValue(this.maxMinArray);
      this.cleaverService.createFactor(this.cleaverFactorForm.value).subscribe(
        resp=>{
          this.personalArray=[];
          this.maxMinArray=[];
          this.behaviorsArray=[];
          this.cleaverFactorForm.reset();
          let timerInterval
          Swal.fire({
            title: 'Factor creado',
            html: '',
            timer: 1000,
            timerProgressBar: true,
            willOpen: () => {
              Swal.showLoading()
            },
            onClose: () => {
              clearInterval(timerInterval)
            }
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              
            }
          })
        },
        err=>{
          console.log(err);
        }
      )
  }

  addPersonal(){
    if(this.personal.high>this.personal.low){
      this.personalArray.push(this.personal);
      this.personal={
        low:Number,
        high:Number,
        d:"",
        i:"",
        s:"",
        c:""
      };

    }
  }

  addBehavior(){
    if(this.behavior.combination!='default'){
      this.behaviorsArray.push(this.behavior);
      this.behavior={
        combination:"default",
        title:"", 
        description:""
      };
    }
  }

  addMaxMin(){
    if(this.maxMin.tag!='default'){
      this.maxMinArray.push(this.maxMin);
      this.maxMin={
        tag:"default",
        title:"", 
        description:"",
        wish:'',
        require:''
      };
    }
  }
  reset(){
    this.cleaverFactorForm.reset();
    this.maxMinArray=[];
    this.personalArray=[];
    this.behaviorsArray=[];
  }
}
